import React, { useEffect, useState }  from "react";
import { fetchAssessments } from "../../api";
import {
  PDFViewer
} from "@react-pdf/renderer";
import MyDocumentSelf from "./MyDocumentSelf";
import { useLocation, useSearchParams } from "react-router-dom";

function SelfReport() {

    const [searchParams, setSearchParams] = useSearchParams()

    const id = searchParams.get('assessmentId')

    
    const [apiData, setApiData] = useState([])

  useEffect(() => {
    fetch(
      process.env.REACT_APP_API_URI + "/v3/user/assessment/" + id + "/results",
      {
        method: "GET",
        mode: "cors",
        headers: { "Content-Type": "application/json" },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.status === "success") {
          console.log("data is here")
          console.log(data);

          const variableMap = data?.variables?.reduce((acc, el) => {
            acc[el.variable] = el.score;
            return acc;
          }, {});
          console.log("variableMap",variableMap)
          setApiData(data);
        } else {
        }
      })
      .catch((err) => {
        console.error("Failed to fetch results...", err);
      });
  }, [id])

  console.log('apiData', apiData)

  return (
    <div style={{ width: "1440px" }}>
      <h1>PDF Generator</h1>
      <PDFViewer width="100%" height="600px">
        <MyDocumentSelf apiData={apiData} />
      </PDFViewer>
    </div>
  );
}

export default SelfReport;
